// @flow

import React, { useState } from 'react';
import { useStore } from '../../store';
import { truncateString } from '../../utils/jsUtils';

import Hidden from '@mui/material/Hidden';
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import PhoneIcon from '@mui/icons-material/Phone';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

import { calculateCreditsForMsg } from '../../models/Message';
import { log } from '../../utils/jsUtils';
import UserProfileMenu from '../UserProfileMenu';
import ForwardRef from '../SharedComponents/ForwardRef';
import Mailto from '../Mailto';
import {
  shareRequestEmailHeaders,
  renderAddress,
  allowActionPerStatus,
  REF_ACTIONS
} from '../../models/Request';
import MessageTenantDialog from '../Tenants/MessageTenantDialog';
import VoiceCallDialog from '../Tenants/VoiceCallDialog';
import SPBackend from '../../services/SPBackend';
import { useI18n } from '../../contexts/I18nContext';

import memberHeaderStyles from './Styles/MemberHeader.Style';

import type { Task, Unit } from '../../services/SPBackend';

type Props = {
  isDemoMode: bool,
  mobileOpen: bool, 
  usehandleDrawerToggle: Function,
  request: Task,
  unit: Unit,
  refreshRequestDetails: Function,
  updateRequestStatus: Function,
  setOpenAssignTaskDialog: Function
};

const RequestHeader = (props: Props) => {
  // log('[RequestHeader] props: ', props);
  const {
    usehandleDrawerToggle,
    request,
    refreshRequestDetails,
    setOpenAssignTaskDialog
  } = props;
  // const [isLoadingMarkAsCurrent, setLoadingMarkAsCurrent] = useState(false);
  // const [isLoadingMarkAsFinished, setLoadingMarkAsFinished] = useState(false);
  // const [openPrivateMessageDialog, setOpenPrivateMessageDialog] = useState(false);
  // const ref = React.createRef();
  const theme = useTheme();
  const [store, dispatch] = useStore();
  const {
    user,
    accountUsage
  } = store;
  const i18n = useI18n();
  const [openCallDialog, setOpenCallDialog] = useState(false);
  log('[RequestHeader] request: ', request);

//   const handleSendReply = (tenant, messagePayload, successCallback, failureCallback) => {
//     log('[handleSendReply][sendPMToTenant] tenant, message: ', tenant, messagePayload);
//     log('[handleSendReply][sendPMToTenant] msg line split: ', messagePayload.message.split('\n'));
//     // verify that credit balance is sufficient
//     const creditsNeeded = calculateCreditsForMsg(messagePayload);
//     log('[sendBroadcast] creditsNeeded: ', creditsNeeded);
//     if (accountUsage.TotalCreditsBalance < creditsNeeded) {
//       failureCallback(`Not enough credits to send this message.
// <br />Visit <a href="/billing">Billing</a> to <b>add a minimum of <u>${creditsNeeded - accountUsage.TotalCreditsBalance} credits</u></b> to your account.
// <br />${creditsNeeded} credits total will be used to send this message.`);
//     } else {
//       if (user !== null) {
//         SPBackend.sendPMToTenant(tenant._id, request._id, messagePayload, user)
//           .then((response) => {
//             const { data } = response;
//             log('[handleSendReply][sendPMToTenant] response: ', tenant, response);
//             dispatch({
//               type: 'ACTION_SET_SNACK_MSG', 
//               snackMessage: {
//                 message: data.message,
//                 level: data.success,
//                 duration: 3000
//               }
//             });
//             refreshRequestDetails();
//             successCallback();
//           })
//           .catch(error => {
//             log('[handleSendReply][sendPMToTenant] error: ', error);
//             dispatch({
//               type: 'ACTION_SET_SNACK_MSG', 
//               snackMessage: {
//                 message: 'An error occured. Please try again.',
//                 level: 'error',
//                 duration: 3000
//               }
//             });
//             failureCallback();  
//           });
//       }
//     }
//   };

  return (
    <AppBar 
      sx={memberHeaderStyles.appBar(theme)}
      position="fixed"
    >
      <Toolbar
        sx={memberHeaderStyles.toolbar(theme)}
        disableGutters
      >
        <Grid 
          container
          direction='column'
        >
          <Grid 
            sx={{
              ...memberHeaderStyles.rowSub(theme),
              ...memberHeaderStyles.topBar(theme)
            }}
            item
          >
        
            <Grid
              sx={memberHeaderStyles.rowSubContainer(theme)}
              container
              justifyContent='flex-start'
            >
              <IconButton
                aria-label="Open drawer"
                sx={memberHeaderStyles.menuButton(theme)}
                color="inherit"
                onClick={usehandleDrawerToggle}
              >
                <MenuIcon />
              </IconButton>
            </Grid> 
            <Grid item>
              <Typography 
                sx={memberHeaderStyles.pageTitle(theme)}
                variant='h2'
              >
                <Hidden mdUp>
                  {request ? truncateString(request.Issue) : null}
                </Hidden>
                <Hidden smDown>
                  <a href='/member'>{i18n.t('Activity')}</a>{` > ${request ? truncateString(request.Issue) : ''}`}
                </Hidden>
              </Typography>
            </Grid>  
            <Box sx={memberHeaderStyles.grow(theme)} />
            <UserProfileMenu />         

          </Grid>
          <Grid
            sx={{
              ...memberHeaderStyles.rowSub(theme),
              ...memberHeaderStyles.bottomBar(theme)
            }}
            item
          >
            <Grid
              sx={memberHeaderStyles.bottomBarContainer(theme)}
              container
            >
            {/* {
              request && allowActionPerStatus(REF_ACTIONS.SEND_NOTE, request.Status)
              ? <div 
                  className={classNames(
                    classes.toggleContainer,
                    classes.dividerRight
                  )}
                >
                  <Tooltip
                    aria-label={i18n.t('Send a reply')}
                    title={i18n.t('Send a reply')}
                  >
                    <IconButton
                      aria-label={'Send a reply'}
                      className={classes.navButton}
                      onClick={e => {
                        e.stopPropagation();
                        setOpenPrivateMessageDialog(true);
                      }}
                    >
                      <i className={'icon-sent'} />
                      <div>{'Reply'}</div>
                    </IconButton>
                    {/* <ForwardRef>
                      <Broadcast
                        scope='request'
                        triggerAction={sendNote}
                      />
                    </ForwardRef> */}
                  {/* </Tooltip>
                </div>
              : null
            } */} 

            {/* {
              request && allowActionPerStatus(REF_ACTIONS.MARK_AS_PROGRESS, request.Status)
              ? <div 
                  className={classNames(
                    classes.toggleContainer
                    )}
                >
                  <Tooltip 
                    aria-label={'Mark as "in Progress"'}
                    title={'Mark as "in Progress"'} 
                  >
                    <ForwardRef>
                    <Button
                      className={classes.navButton}
                      onClick={updateRequestStatus('CURRENT', setLoadingMarkAsCurrent)}
                      value="In Progress"
                    >
                    {
                      isLoadingMarkAsCurrent
                      ? <CircularProgress
                        onClick={(e) => e.stopPropagation()}
                        size={24}
                        />
                      : <i className={'icon-progress'} />
                    }
                      <div>{'In progress'}</div>
                    </Button>
                    </ForwardRef>
                  </Tooltip>
                </div>
              : null
            }  
            {
              request && allowActionPerStatus(REF_ACTIONS.MARK_AS_DONE, request.Status)
              ? <div 
                  className={classNames(
                    classes.toggleContainer
                    )}
                >
                  <Tooltip 
                    aria-label={'Mark as "Done"'}
                    title={'Mark as "Done"'} 
                  >
                    <ForwardRef>
                    <Button
                      className={classes.navButton}
                      onClick={updateRequestStatus('FINISHED', setLoadingMarkAsFinished)}
                      value="Done"
                    >
                    {
                      isLoadingMarkAsFinished
                      ? <CircularProgress
                        onClick={(e) => e.stopPropagation()}
                        size={24}
                        />
                      : <i className={'icon-finished'} />
                    }
                      <div>{'Done'}</div>
                    </Button>
                    </ForwardRef>
                  </Tooltip>
                </div>
              : null
            } */}
            
              {
                request
                && allowActionPerStatus(REF_ACTIONS.SHARE, request.Status)
                ? <Box
                    sx={memberHeaderStyles.toggleContainer(theme)}
                  >
                    <Tooltip
                      aria-label={'Assign'}
                      title={'Assign'}
                    >
                    <ForwardRef>
                      <Button
                        sx={memberHeaderStyles.navButton(theme)}
                        onClick={() => setOpenAssignTaskDialog(true)}
                      >
                        <i className={'icon-assign'} />
                        <div>{'Assign'}</div>
                      </Button>
                      </ForwardRef>
                    </Tooltip>
                  </Box>
                : null
              }
              {
                request
                && request.lookupTenant
                && request.lookupTenant.Phone
                ? <Box sx={memberHeaderStyles.toggleContainer(theme)}>
                    <Tooltip aria-label={'Call Customer'} title={'Call Customer'}>
                      <ForwardRef>
                        <Button
                          sx={memberHeaderStyles.navButton(theme)}
                          onClick={() => setOpenCallDialog(true)}
                        >
                          <PhoneIcon />
                          <div>{'Call'}</div>
                        </Button>
                      </ForwardRef>
                    </Tooltip>
                  </Box>
                : null
              }
              {/* {
                request
                && allowActionPerStatus(REF_ACTIONS.SHARE, request.Status)
                ? <div 
                    className={classNames(
                      classes.toggleContainer,
                      classes.dividerRight
                    )}
                  >
                    <Mailto 
                      email={null}
                      headers={shareRequestEmailHeaders(request, userFullName, renderAddress(unit))}
                      obfuscate={false}
                    >
                      <Tooltip 
                        aria-label={'Share Request'}
                        title={'Share Request'} 
                      >
                        <ForwardRef>
                        <Button
                          className={
                            classes.navButton}
                          value="Share"
                        >
                          <i className={'icon-share'} />
                          <div>{'Share'}</div>
                        </Button>
                        </ForwardRef>
                      </Tooltip>
                    </Mailto>
                  </div>
                : null
              } */}
              
              {/* {
                request 
                && allowActionPerStatus(REF_ACTIONS.MERGE, request.Status)
                && isDemoMode
                ? <div 
                    className={classNames(
                      classes.toggleContainer
                    )}
                  >
                    <Tooltip 
                      aria-label={'Merge'}
                      title={'Merge'} 
                    >
                      <ForwardRef>
                      <Button
                        className={classes.navButton}
                      >
                        <i className={'icon-merge'} />
                        <div>{'Merge'}</div>
                      </Button>
                      </ForwardRef>
                    </Tooltip>
                  </div>
                : null
              }
              
              {
                request 
                && allowActionPerStatus(REF_ACTIONS.SPLIT, request.Status)
                && isDemoMode
                ? <div 
                    className={classNames(
                      classes.toggleContainer
                    )}
                  >
                    <Tooltip 
                      aria-label={'Split'}
                      title={'Split'} 
                    >
                      <ForwardRef>
                      <Button
                        className={classes.navButton}
                      >
                        <i className={'icon-split'} />
                        <div>{'Split'}</div>
                      </Button>
                      </ForwardRef>
                    </Tooltip>
                  </div>
                : null
              } */}

              <Box sx={memberHeaderStyles.grow(theme)} />
              
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>
      {/* <MessageTenantDialog
        open={openPrivateMessageDialog}
        setOpen={setOpenPrivateMessageDialog}
        tenant={request ? request.lookupTenant : null}
        triggerAction={handleSendReply}
      /> */}
      <VoiceCallDialog
        open={openCallDialog}
        setOpen={setOpenCallDialog}
        tenant={request ? request.lookupTenant : null}
      />
    </AppBar>
  );
};

export default RequestHeader;
